areaMembros.component('areaMembros.ajudaEditComponent', {
    templateUrl: 'areaMembros/areaMembrosDetalhe/ajudaEdit/ajudaEdit.html',
    controller: 'areaMembros.ajudaController',
    controllerAs: '$ctrl',
    bindings: { areaMembros: '<' }
});

areaMembros.controller('areaMembros.ajudaController', ['$scope', 'coreLanguage', '$state', 'coreFb', 'coreToast', '$filter', function($scope, $text, $state, $fb, $toast, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.setViewForm=(value)=>{
        $ctrl.viewForm = value;
    };

    $ctrl.setViewFormBanner=(value)=>{
        $ctrl.viewFormBanner = value;
    };

    $ctrl.uploadBanner=(event, mobile=false)=>{

        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingFile=true;

        $fb.storage.upload(`/areaMembros/${$ctrl.areaMembros.id}/ajuda`, event.target.files[0]).then(url => {
            if(!$ctrl.areaMembros.data.ajuda){ $ctrl.areaMembros.data.ajuda = {}; }
            if(!mobile){
                $ctrl.areaMembros.data.ajuda.capaUrl = url;
            }else{
                $ctrl.areaMembros.data.ajuda.capaMobileUrl = url;
            }

            $ctrl.loadingFile=false;
        });
    };

    $ctrl.updateBanner=()=>{
        $state.params.showGlobalLoading = true;
        
        $fb.db.update($ctrl.areaMembros.path, {
            'ajuda.capaUrl': $ctrl.areaMembros.data.ajuda.capaUrl,
            'ajuda.capaMobUrl': $ctrl.areaMembros.data.ajuda.capaMobUrl
        }).then(()=>{
            $ctrl.setViewFormBanner(false);
            $state.params.showGlobalLoading = false;
        });
    };
    
    $ctrl.updateArea=()=>{
        $state.params.showGlobalLoading = true;
        
        $fb.db.update($ctrl.areaMembros.path, {'ajuda.nome': $ctrl.areaMembros.data.ajuda.nome, 'ajuda.subtitulo': $ctrl.areaMembros.data.ajuda.subtitulo}).then(()=>{
            $ctrl.setViewForm(false);
            $state.params.showGlobalLoading = false;
        });
    };

}]);